module.exports = __webpack_public_path__ + "img/Noctiluca-Process-1-mobile.2462d2a2.png";